function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.1875 11.2969H7.07812V9.1875C7.07812 8.79919 6.76331 8.48438 6.375 8.48438C5.98669 8.48438 5.67188 8.79919 5.67188 9.1875V11.2969H3.5625C3.17419 11.2969 2.85938 11.6117 2.85938 12C2.85938 12.3883 3.17419 12.7031 3.5625 12.7031H5.67188V14.8125C5.67188 15.2008 5.98669 15.5156 6.375 15.5156C6.76331 15.5156 7.07812 15.2008 7.07812 14.8125V12.7031H9.1875C9.57581 12.7031 9.89062 12.3883 9.89062 12C9.89062 11.6117 9.57581 11.2969 9.1875 11.2969Z",
  fill: "#D18F1F"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1094 12C14.1094 12.3883 14.4242 12.7031 14.8125 12.7031H20.4844C20.8727 12.7031 21.1875 12.3883 21.1875 12C21.1875 11.6117 20.8727 11.2969 20.4844 11.2969H14.8125C14.4242 11.2969 14.1094 11.6117 14.1094 12Z",
  fill: "#D18F1F"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.39255 0 0 5.39297 0 12C0 18.6075 5.39297 24 12 24C18.6075 24 24 18.607 24 12C24 5.39255 18.607 0 12 0ZM1.40625 12C1.40625 6.39492 5.78208 1.79334 11.2969 1.43016V22.5698C5.78208 22.2067 1.40625 17.6051 1.40625 12ZM12.7031 22.5698V1.43016C18.2179 1.79334 22.5938 6.39492 22.5938 12C22.5938 17.6051 18.2179 22.2067 12.7031 22.5698Z",
  fill: "#D18F1F"
});
function SvgPlusMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusMinus);
export default __webpack_public_path__ + "static/media/plus-minus.2bad8f5ba9ef7fe152f9137fe71316ea.svg";
export { ForwardRef as ReactComponent };